import React, { Component } from 'react';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import { hot } from 'react-hot-loader';

import Navigation from './Navigation';
import LandingPage from './Landing';
import SignUpPage from './SignUp';
import SignInPage from './SignIn';
import PasswordForgetPage from './PasswordForget';
import HomePage from './Home';
import AccountPage from './Account';
import RentPage from './Rent';

import * as routes from '../constants/routes';

import withAuthentication from './withAuthentication';
import SideNav from './SideNav';
import Numbers from './Numbers';

const reload = () => window.location.reload();

const App = () => (
  <Router>
    <div>
      {/* <Navigation /> */}
      {/* <hr /> */}

      <Route exact path={routes.LANDING} component={() => <LandingPage />} />
      <Route exact path={routes.SIGN_UP} component={() => <SignUpPage />} />
      <Route exact path={routes.SIGN_IN} component={() => <SignInPage />} />
      <Route
        exact
        path={routes.PASSWORD_FORGET}
        component={() => <PasswordForgetPage />}
      />
      <Route
        exact
        path={routes.HOME}
        component={() => <SideNav page={<HomePage />} />}
      />
      <Route
        exact
        path={routes.ACCOUNT}
        component={() => (
          <SideNav page={<AccountPage />} name="Account Settings" />
        )}
      />
      <Route
        exact
        path={routes.RENT}
        component={() => <SideNav page={<RentPage />} name="Your Numbers" />}
      />
      <Route
        exact
        path={routes.NUMBERS}
        component={() => (
          <SideNav paged="numbers" page={<Numbers />} name="Numbers Panel" />
        )}
      />
      <Route exact path={routes.SIDENAV} component={() => <SideNav />} />
    </div>
  </Router>
);

// className App extends Component{
//   constructor(props) {
//     super(props);

//     this.state = {
//       authUser: null,
//     };
//   }

//   componentDidMount() {
//     firebase.auth.onAuthStateChanged(authUser => {
//       authUser ? this.setState( () => ({ authUser })) : this.setState( () => ({ authUser:null }));
//     });
//   }

//   render() {
//     return (
//       <Router>
//         <div>
//           <Navigation authUser={this.state.authUser} />

//           <hr />

//           <Route exact path={routes.LANDING} component={() => <LandingPage />} />
//           <Route exact path={routes.SIGN_UP} component={() => <SignUpPage />} />
//           <Route exact path={routes.SIGN_IN} component={() => <SignInPage />} />
//           <Route exact path={routes.PASSWORD_FORGET} component={() => <PasswordForgetPage />} />
//           <Route exact path={routes.HOME} component={() => <HomePage />} />
//           <Route exact path={routes.ACCOUNT} component={() => <AccountPage />} />
//         </div>
//       </Router>
//     );
//   }
// }

// export default withAuthentication(App);
// export default withAuthentication(App);
export default hot(module)(withAuthentication(App));
